import { render, staticRenderFns } from "./ProjectPicker.vue?vue&type=template&id=cf51bd5e&"
import script from "./ProjectPicker.vue?vue&type=script&lang=js&"
export * from "./ProjectPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VBtn,VChip})
